import { render } from "./FeatureSection.vue?vue&type=template&id=65d99580&scoped=true"
import script from "./FeatureSection.vue?vue&type=script&lang=js"
export * from "./FeatureSection.vue?vue&type=script&lang=js"

import "./FeatureSection.vue?vue&type=style&index=0&id=65d99580&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d99580"]])

export default __exports__